import { render } from "./FaultPage.vue?vue&type=template&id=05a42f34"
import script from "./FaultPage.vue?vue&type=script&lang=js"
export * from "./FaultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AfterSales/editTask/FaultPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05a42f34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05a42f34', __exports__)) {
    api.reload('05a42f34', __exports__)
  }
  
  module.hot.accept("./FaultPage.vue?vue&type=template&id=05a42f34", () => {
    api.rerender('05a42f34', render)
  })

}


export default __exports__